declare global {
  interface Window {
    ApplePaySession?: typeof ApplePaySession
  }
}

export const hasApplePaySDK = (): boolean => {
  return typeof window !== 'undefined' && typeof window.ApplePaySession !== 'undefined'
}

export enum PaymentFormType {
  Single = 'single',
  Multiple = 'multiple',
}

export enum PaymentTypes {
  CreditCard = 'creditCard',
  Klarna = 'klarna',
  GiroPay = 'giropay',
  Ideal = 'ideal',
  Multibanco = 'multibanco',
  Bancontact = 'bancontact',
}

export const PaymentTypeToNameMap: Record<PaymentTypes, string> = {
  [PaymentTypes.CreditCard]: 'Credit Card',
  [PaymentTypes.Klarna]: 'Klarna',
  [PaymentTypes.GiroPay]: 'GiroPay',
  [PaymentTypes.Ideal]: 'iDeal',
  [PaymentTypes.Multibanco]: 'Multibanco',
  [PaymentTypes.Bancontact]: 'Bancontact',
}

export enum PaymentMessages {
  VALIDATION_3DS = '3DS_VALIDATION',
  PAYMENT = 'PAYMENT',
}

export enum PaymentStatus {
  FAILED = 'failed',
  SUCCESS = 'success',
  PENDING = 'pending',
  ERROR = 'error',
}

export const isPaymentType = (value: string): value is PaymentMessages => {
  return Object.values(PaymentMessages).includes(value as PaymentMessages)
}

export const isPaymentStatus = (value: string): value is PaymentStatus => {
  return Object.values(PaymentStatus).includes(value as PaymentStatus)
}
